import { render, staticRenderFns } from "./DocumentwithName.vue?vue&type=template&id=f18ad416&scoped=true"
import script from "./DocumentwithName.vue?vue&type=script&lang=js"
export * from "./DocumentwithName.vue?vue&type=script&lang=js"
import style0 from "./DocumentwithName.vue?vue&type=style&index=0&id=f18ad416&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f18ad416",
  null
  
)

export default component.exports